import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProcessService } from 'src/app/services/process.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { ProcessCreate, Process, ProcessEdit } from 'src/app/models/process.model';
import { Jobtype } from 'src/app/models/jobtype.model';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { fromJobtypes } from 'src/app/reducers/jobtypes.reducer';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { Office } from 'src/app/models/office.model';
import { fromProcesses } from 'src/app/reducers/processes.reducer';
import { UtilsService } from 'src/app/services/utils.service';
import { take } from 'rxjs/operators';
import { Consultant } from 'src/app/models/consultant.model';
import { Pagination } from 'src/app/models/pagination.model';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from 'src/app/helpers/app.config';
@Component({
  selector: 'ct-detail-process',
  templateUrl: './process-detail.component.html',
  styleUrls: ['./process-detail.component.scss']
})
export class ProcessDetailComponent implements OnInit, OnDestroy {

  @ViewChild('content') content;

  modalRef: NgbModalRef;
  closeResult: string;

  jobtypes$: Observable<Jobtype[]>;
  consultant$: Observable<Consultant>;
  currentConsultant: Consultant;
  processes$: Observable<Pagination<Process>>;

  jobtype: number;
  office: Office;
  processId: number;
  processSelected: Process;
  jobtypeSelected: Jobtype;

  action: string;

  detailProcessForm: FormGroup = this.fb.group({
    office: [{ value: '', disabled: true }, Validators.required],
    jobtype: [{ value: '', disabled: true }],
    name: ['', Validators.required],
    description: [''],
    origin: [''],
    consultantId: [''],
    authorization: ['']
  });

  processesSubscription: Subscription;

  constructor(
    private store: Store,
    private router: Router,
    private fb: FormBuilder,
    public utilsService: UtilsService,
    private processService: ProcessService,
    private activatedRoute: ActivatedRoute,
    public utils: UtilsService,
    private modal: NgbModal,
  ) { }

  ngOnInit(): void {

    if (this.router.url.includes('show')) {
      this.action = 'SHOW';
    } else if (this.router.url.includes('edit')) {
      this.action = 'EDIT';
    }

    this.processId = Number(this.activatedRoute.snapshot.paramMap.get('id'));

    this.jobtypes$ = this.store.pipe(select(fromJobtypes.selectBusinessJobtypes));
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
    this.processes$ = this.store.pipe(select(fromProcesses.selectProcessesState));

    this.processesSubscription = combineLatest([
      this.processes$,
      this.consultant$,
    ]).pipe(take(1)).subscribe(([processes, consultant]) => {
      if (consultant) {
        this.currentConsultant = consultant;
        this.office = consultant.office;
        this.detailProcessForm.get('office').setValue(consultant.office.name);
        this.detailProcessForm.get('consultantId').setValue(consultant.raas.nameid);
      }
      this.processSelected = processes.data.find(process => process.id === this.processId);

      // comprobamos que el proceso que se intenta acceder existe,  no es el General y pertenece a la oficina seleccionada
      if (!this.processSelected || this.processSelected.officeId === undefined || this.processSelected.officeId !== consultant.office.id) {
        this.router.navigate(['consultant/processes']);
      } else {
        this.detailProcessForm.get('name').setValue(this.processSelected.name);
        this.detailProcessForm.get('description').setValue(this.processSelected.description);
        this.jobtypeSelected = this.utils.jobtypeFromJobtypeId(this.processSelected.jobtypeId);
        this.detailProcessForm.get('jobtype').setValue(this.processSelected.jobtypeId);
        // this.jobtype = this.processSelected.jobtypeId;
      }
      this.detailProcessForm.get('origin').setValue(this.processSelected.origin);
      this.detailProcessForm.get('authorization').setValue(consultant.token);
    });
  }

  onSubmit() {
    this.processService.edit({
      id: this.processId,
      name: this.detailProcessForm.get('name').value,
      description: this.detailProcessForm.get('description').value,
      origin: this.detailProcessForm.get('origin').value,
      consultantId: this.detailProcessForm.get('consultantId').value,
      authorization: this.detailProcessForm.get('authorization').value,
      officeId: this.processSelected.officeId,
      clientId: this.currentConsultant.client.id
    } as ProcessEdit).subscribe(
      result => {
        this.utilsService.toast('success', 'ProcessEdited');
        this.router.navigate(['consultant/processes']);
      },
      error => {
        if (error.message === 'ya existe un proceso con ese nombre en esa oficina') {
          this.utilsService.toast('warning', 'ProcessAlreadyExists');
        } else if (error?.cause?.cause !== undefined) {
          switch (error.cause.cause.errorCode) {
            case 4031:
            this.utilsService.toast('error', 'ConsultantNotHavePermission');
            this.router.navigate(['consultant/processes']);
            break;
            case 4032:
            this.utilsService.toast('error', 'ProfileCanNotDelete');
            this.router.navigate(['consultant/processes']);
            break;
          }
        }  else {
          this.utilsService.toast('error', 'CannotEditProcess', true, this.utilsService.getNacsData({endpoint: 'PUT' + AppConfig.settings.API + ' /processes?origin=ct', body: {id: this.processId,name: this.detailProcessForm.get('name').value,description: this.detailProcessForm.get('description').value,origin: this.detailProcessForm.get('origin').value,consultantId: this.detailProcessForm.get('consultantId').value,authorization: this.detailProcessForm.get('authorization').value,officeId: this.processSelected.officeId}, error: {errorType: error.errorType, errorCode: error.errorCode, message: error.message}}));
        }
      }
    );
  }

  showModalViewSkills(jobtype: Jobtype) {
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.content, { ariaLabelledBy: 'Ver-Competencias', size: 'l' });
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        this.closeResult = 'Dismissed ' + this.getDismissReason(reason);
      });
    }
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ' + reason;
    }
  }

  ngOnDestroy(): void {
    this.processesSubscription.unsubscribe();
  }
}
